import {Branded} from 'io-ts';

/*
 * Brand types.
 */

interface ApplicationActivityIdBrand {
  readonly publicIdActivity: unique symbol;
}

interface ApplicationAttachmentIdBrand {
  readonly publicIdAttachment: unique symbol;
}

interface ApplicationCalendarEventIdBrand {
  readonly publicIdCalendarEvent: unique symbol;
}

interface ApplicationCalendarEventVersionIdBrand {
  readonly publicIdCalendarEventVersion: unique symbol;
}

interface ApplicationCannedAnswerIdBrand {
  readonly publicIdCannedAnswer: unique symbol;
}

interface ApplicationCardIdBrand {
  readonly publicIdCard: unique symbol;
}

interface ApplicationCardGroupIdBrand {
  readonly publicIdCardGroup: unique symbol;
}

interface ApplicationChannelIdBrand {
  readonly publicIdChannel: unique symbol;
}

interface ApplicationCommentIdBrand {
  readonly publicIdComment: unique symbol;
}

interface ApplicationConversationIdBrand {
  readonly publicIdConversation: unique symbol;
}

interface ApplicationCustomFieldIdBrand {
  readonly publicIdCustomField: unique symbol;
}

interface ApplicationDraftIdBrand {
  readonly publicUidDraft: unique symbol;
}

interface ApplicationInboxIdBrand {
  readonly publicIdInbox: unique symbol;
}

interface ApplicationMessageIdBrand {
  readonly publicIdMessage: unique symbol;
}

interface ApplicationRuleIdBrand {
  readonly publicIdRule: unique symbol;
}

interface ApplicationTagIdBrand {
  readonly publicIdTag: unique symbol;
}

interface ApplicationTeamIdBrand {
  readonly publicIdTeam: unique symbol;
}

interface ApplicationTeammateIdBrand {
  readonly publicIdTeammate: unique symbol;
}

interface ApplicationTopicIdBrand {
  readonly publicIdTopic: unique symbol;
}

interface ApplicationCircleIdBrand {
  readonly publicIdCircle: unique symbol;
}

export type ApplicationResourceIdBrand = ApplicationActivityIdBrand &
  ApplicationAttachmentIdBrand &
  ApplicationCalendarEventIdBrand &
  ApplicationCalendarEventVersionIdBrand &
  ApplicationCannedAnswerIdBrand &
  ApplicationCardIdBrand &
  ApplicationCardGroupIdBrand &
  ApplicationChannelIdBrand &
  ApplicationCircleIdBrand &
  ApplicationCommentIdBrand &
  ApplicationConversationIdBrand &
  ApplicationCustomFieldIdBrand &
  ApplicationDraftIdBrand &
  ApplicationInboxIdBrand &
  ApplicationMessageIdBrand &
  ApplicationRuleIdBrand &
  ApplicationTagIdBrand &
  ApplicationTeamIdBrand &
  ApplicationTeammateIdBrand &
  ApplicationTopicIdBrand;

/*
 * Public ID types.
 */

export type ApplicationAttachmentId = Branded<string, ApplicationAttachmentIdBrand>;
export type ApplicationCannedAnswerId = Branded<string, ApplicationCannedAnswerIdBrand>;
export type ApplicationChannelId = Branded<string, ApplicationChannelIdBrand>;
export type ApplicationContactId = Branded<string, ApplicationCardIdBrand>;
export type ApplicationContactGroupId = Branded<string, ApplicationCardGroupIdBrand>;
export type ApplicationCommentId = Branded<string, ApplicationCommentIdBrand>;
export type ApplicationConversationId = Branded<string, ApplicationConversationIdBrand>;
export type ApplicationCustomFieldId = Branded<string, ApplicationCustomFieldIdBrand>;
export type ApplicationDraftId = Branded<string, ApplicationDraftIdBrand>;
export type ApplicationInboxId = Branded<string, ApplicationInboxIdBrand>;
export type ApplicationMessageId = Branded<string, ApplicationMessageIdBrand>;
export type ApplicationTagId = Branded<string, ApplicationTagIdBrand>;
export type ApplicationTeamId = Branded<string, ApplicationTeamIdBrand>;
export type ApplicationTeammateId = Branded<string, ApplicationTeammateIdBrand>;
export type ApplicationTopicId = Branded<string, ApplicationTopicIdBrand>;

export const applicationCompanyId = 'company';
export type ApplicationCompanyId = typeof applicationCompanyId;
